import React, {
  ReactNode,
} from 'react';
import Accordion from 'core/components/Accordion';
import isNil from 'lodash/isNil';

type Props = {
  title?: ReactNode | string;
  headerActions?: ReactNode;
  children?: ReactNode;
  disabled?: boolean;
};

export default function Section({
  title: _title,
  headerActions,
  disabled = false,
  children,
}: Props) {
  const title = typeof _title === 'string' ? (<h2>{_title}</h2>) : _title;
  return (
    <Accordion
      defaultExpanded
      header={title}
      headerActions={headerActions}
      disableGutters
      disabled={disabled}
      headerClasses={{
        root: '!px-2 !py-1 !min-h-[initial] !bg-gray-100 !text-gray-600 !font-semibold text-sm',
        content: `!m-0 ${!isNil(headerActions) ? '!pr-40' : ''}`,
      }}
      detailsClasses={{ root: '!p-0 populate-form flex flex-col w-full' }}
    >
      {children ?? ''}
    </Accordion>
  );
}
